import React from 'react';
import type { FC } from 'react';
import { Backdrop, Box, Stack, keyframes } from '@mui/material';
import Logo from '../Logo';
import EnergoLoadingOperation from "../EnergoLoadingOperation";

// Definizione animazioni con keyframes

interface EnergoLoadingOperationProps {
  visible: boolean;
}

const MyLoadingOperation: FC<EnergoLoadingOperationProps> = ({ visible }) => {
  return (
      <EnergoLoadingOperation visible={visible}/>
  );
};

export default MyLoadingOperation;
